import { CheckCircleOutlined, EllipsisOutlined, EyeInvisibleOutlined } from ".."

import type { Type } from "@/domain/resource"

export const FindingStatusIcon = ({
  type
}: {
  type: Type | "partially-resolved"
}) => {
  if (type === "partially-resolved") return <EllipsisOutlined />
  if (type === "Image") return <EyeInvisibleOutlined />

  return <CheckCircleOutlined />
}
